module.exports = require("@material-ui/icons/esm/CloudDownload");